import React from "react";
import "./ProductDetailComponent.css";
import { Apiurl, Encryption } from "../../Pages/utils/page";
import ProductCountdown from "../Countdown/Countdown";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import { ClipLoader } from "react-spinners";
import { Button, Form, Modal } from "react-bootstrap";

const ProductDetailComponent = ({
  productDetail,
  productsByVendor,
  handleAddToCart,
  handleAddBid,
  setValueofbid,
  bidAmountValue,
  valueOfBid,
  loading,
  setLoading,
  handleGetProduct,
  handleCloseAddress,
  showAddressModal,
  Address,
  setAddress,
  handleAddAddress,
  setShowProductImage,
  showProductImage,
}) => {
  console.log(productDetail, "productDetail");
  const router = useNavigate();
  const now2 = moment(); // Current time
  const timeTocheck = moment(productDetail?.ToPushlishDate);
  const timeDifferenceInHoursCheck = timeTocheck.diff(now2, "hours");

  return (
    <>
      <div className="background-bg-setion" style={{ flex: "1" }}>
        <div>
          <div className="detail_pro_hgt">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 mb_commn_pd_0">
                  <div className="product_info_wraper">
                    <div className="Cus_shadow pro_tp_section_spc">
                      <div className="row">
                        <div className="col-lg-6 col-sm-6 col-12">
                          <div className="auction-gallery-timer">
                            {timeDifferenceInHoursCheck > 24 ? (
                              <h3>
                                <strong>
                                  Till:{" "}
                                  {moment(productDetail?.ToPushlishDate).format(
                                    "LL"
                                  )}
                                </strong>
                              </h3>
                            ) : (
                              <ProductCountdown
                                item={productDetail}
                                val="tillTime"
                              />
                            )}
                          </div>

                          <img
                            src={showProductImage}
                            className="w-100  "
                            alt="No Image"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/Images/no-product-img-700.jpg";
                            }}
                          />
                          <div className="col-lg-5 col-sm-5 col-12 mt-3 d-flex image-multiple-section">
                            {JSON.parse(productDetail?.Images || "[]").map(
                              (item) => {
                                return (
                                  <img
                                    src={`${Apiurl()}/${item?.Images}`}
                                    style={{ cursor: "pointer" }}
                                    className={
                                      `${Apiurl()}/${item?.Images}` ==
                                      showProductImage
                                        ? "w-100 mt-2 thumbnail highlighted_image"
                                        : "w-100 mt-2 thumbnail highlighted"
                                    }
                                    alt="No Image"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "/image/no-product-img-700.jpg";
                                    }}
                                    onClick={() => {
                                      setShowProductImage(
                                        `${Apiurl()}/${item?.Images}`
                                      );
                                    }}
                                  />
                                );
                              }
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                          <h2>{productDetail?.ProductName}</h2>
                          <p>{productDetail?.ProductDescription}</p>
                          {productDetail?.IsProductInOffer === false ? (
                            <h5>
                              ₹{productDetail?.DealPrice}
                              <span
                                className="mrp-price"
                                style={{ marginLeft: "8px" }}
                              >
                                ₹{productDetail?.Mrp}
                              </span>
                              {productDetail?.Mrp &&
                                productDetail?.DealPrice && (
                                  <span
                                    className="flat-discount"
                                    style={{ marginLeft: "8px" }}
                                  >
                                    {Math.round(
                                      ((productDetail.Mrp -
                                        productDetail.DealPrice) /
                                        productDetail.Mrp) *
                                        100
                                    )}
                                    % off
                                  </span>
                                )}
                            </h5>
                          ) : null}

                          {/* <h3>
                            MRP: <span>₹ {productDetail?.Mrp}</span>
                          </h3> */}
                          <h6 class="text-muted mb-1" b-es7zw9hdfx="">
                            Seller: {" "}
                            <span class="seller_name" b-es7zw9hdfx="">
                              <a b-es7zw9hdfx="">
                                {productDetail?.BusinessName}
                              </a>
                            </span>
                          </h6>
                          {!productDetail?.IsProductInOffer === true &&(
  <h6 class="hurry_text">
  Hurry, Only {productDetail?.QuantityLeft} left{" "}
</h6>
                          )}

                        

                          {productDetail?.IsProductOutOfStock === true ? (
                            <button
                              type="button"
                              className="common_btn_new out_stock_btn_01"
                            >
                              Out of Stock{" "}
                            </button>
                          ) : (
                            <>
                              <div className="bid-form">
                                <div
                                // onClick={() => {
                                //   router(
                                //     `/productdetail/${Encryption(
                                //       productDetail?.Id
                                //     )}`
                                //   );

                                //   handleGetProduct();
                                //   window.scrollTo(0, 0);
                                // }}
                                >
                                  <h5>
                                    {productDetail?.IsProductInOffer === true
                                      ? "Bid Now"
                                      : productDetail?.IsProductInOffer ===
                                        false
                                      ? "Buy Now"
                                      : productDetail?.IsProductInOffer === null
                                      ? "Contact us"
                                      : null}
                                  </h5>
                                  {productDetail?.IsProductInOffer === true ? (
                                    <p>
                                      Recommened Points:{" "}
                                      <span>
                                        {productDetail?.RecommendedBid}
                                      </span>
                                    </p>
                                  ) : null}
                                </div>

                                {productDetail?.IsProductInOffer === true ? (
                                  <div className="form-inner gap-2">
                                    <input
                                      type="number"
                                      placeholder="enter bid"
                                      onChange={(e) =>
                                        setValueofbid(e?.target?.value)
                                      }
                                      value={valueOfBid}
                                    />
                                    {bidAmountValue ? (
                                      loading === "addBid" ? (
                                        <button
                                          type="button"
                                          className="common_btn"
                                        >
                                          <ClipLoader
                                            loading
                                            size={15}
                                            color="#fff"
                                          />
                                        </button>
                                      ) : loading === "addBid" ? (
                                        <button
                                          type="button"
                                          className="common_btn"
                                        >
                                          {" "}
                                          <ClipLoader
                                            loading
                                            size={15}
                                            color="#fff"
                                          />
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          className="common_btn"
                                          onClick={handleAddBid}
                                        >
                                          Update Bid
                                        </button>
                                      )
                                    ) : loading === "addBid" ? (
                                      <button
                                        type="button"
                                        className="common_btn"
                                      >
                                        {" "}
                                        <ClipLoader
                                          loading
                                          color="#fff"
                                          size={15}
                                        />
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        className="common_btn"
                                        onClick={handleAddBid}
                                      >
                                        Place Bid
                                      </button>
                                    )}
                                  </div>
                                ) : (
                                  <div className="form-inner form-buy-btn gap-2">
                                    {loading === "addBid" ? (
                                      <button
                                        type="button"
                                        className="common_btn "
                                      >
                                        <ClipLoader
                                          loading
                                          size={15}
                                          color="#fff"
                                        />
                                      </button>
                                    ) : productDetail?.IsProductOutOfStock ===
                                      true ? (
                                      <button
                                        type="button"
                                        className="common_btn_new out_stock_btn_01 "
                                      >
                                        Out of Stock
                                      </button>
                                    ) : productDetail?.IsProductInOffer ===
                                      null ? (
                                      <button
                                        type="button"
                                        className="common_btn "
                                      >
                                        Contact Us
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        className="common_btn "
                                        onClick={handleAddToCart}
                                      >
                                        Add to Cart
                                      </button>
                                    )}
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ven_rela_product">
              <div className="container">
                <div className="row">
                  <h4 className="common_heading  mb_commn_pd_0">
                    Affiliate Partner Related Products
                  </h4>
                </div>
                <div className="row">
                  <div className="col-lg-12 mb_commn_pd_0">
                    <div className="affiliate_partner_related-products">
                      <div className="row">
                        {productsByVendor?.map((item) => {
                          const now = moment(); // Current time
                          const timeTo = moment(item?.ToPushlishDate);
                          const timeDifferenceInHours = timeTo.diff(
                            now,
                            "hours"
                          );

                          const imagesArray = JSON.parse(item.Images);

                          const defaultImage = imagesArray.find(
                            (img) => img.Default
                          );

                          const imageUrl = defaultImage
                            ? `${Apiurl()}/${defaultImage.Images}`
                            : "";

                          // const image = item?.Images?.split('"');
                          // const imageUrl = `${Apiurl()}/${image?.[3]}`;
                          return (
                            <div className="col-lg-2 col-6 product_new_btm_spc ">
                              <div className="pro_detail_wrapper_new text-center">
                                <img
                                  src={imageUrl}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      "/Images/no-product-img-700.jpg";
                                  }}
                                  onClick={() => {
                                    router(
                                      `/productdetail/${Encryption(item?.Id)}`
                                    );
                                  }}
                                />
                                <h2>{item?.ProductName} </h2>
                                <h3>
                                  Till:{" "}
                                  {moment(item?.DealPriceDeclareDate).format(
                                    "LL"
                                  )}
                                </h3>
                                {/* {timeDifferenceInHours > 24 ? (
                            <h3>
                              Till:{" "}
                              {moment(
                                item?.DealPriceDeclareDate
                              ).format("LL")}
                            </h3>
                          ) : (
                            <h3>
                              <ProductCountdown
                                item={item}
                                val="tillTime"
                              />
                            </h3>
                          )} */}

                                <h5>
                                  {" "}
                                  ₹ {item?.DealPrice}{" "}
                                  <span className="mrp-price">
                                    ₹{item?.Mrp}
                                  </span>
                                  <span className="flat-dicsount">
                                    {" "}
                                    {Math.round(
                                      ((item.Mrp - item.DealPrice) / item.Mrp) *
                                        100
                                    )}
                                    % off
                                  </span>
                                </h5>
                                {item?.IsProductOutOfStock === true ? (
                                  <input
                                    type="button"
                                    value="Out of Stock"
                                    className="common_btn_new out_stock_btn_01"
                                  />
                                ) : (
                                  <input
                                    type="button"
                                    onClick={() => {
                                      router(
                                        `/productdetail/${Encryption(item?.Id)}`
                                      );
                                    }}
                                    value={
                                      item?.IsProductInOffer == true
                                        ? "Bid Now"
                                        : item?.IsProductInOffer == false
                                        ? "Buy Now"
                                        : item?.IsProductInOffer == null
                                        ? "Contact Us"
                                        : null
                                    }
                                    className={
                                      item?.IsProductInOffer == true
                                        ? "common_btn_new bid_now_btn_01"
                                        : item?.IsProductInOffer == false
                                        ? "common_btn_new"
                                        : item?.IsProductInOffer == null
                                        ? "common_btn_new"
                                        : null
                                    }
                                  />
                                )}
                              </div>
                            </div>
                            // <div className="col-lg-3 col-sm-3 col-6 vendor_related_pro_spc ">
                            //   <div
                            //     className={
                            //       item?.IsProductOutOfStock === true
                            //         ? "pro_detail_wrapper_new blur_effect"
                            //         : "pro_detail_wrapper_new"
                            //     }
                            //   >
                            //     <div className="pro_dtl_main_spc_wrapper">
                            //       <div className="pro_dtl_img_all_spc_wrapper">
                            //         <img
                            //           src={imageUrl}
                            //           alt="No Image"
                            //           onError={(e) => {
                            //             e.target.onerror = null;
                            //             e.target.src =
                            //               "/Images/no-product-img-700.jpg";
                            //           }}
                            //           onClick={() => {
                            //             setShowProductImage(imageUrl);
                            //             router(
                            //               `/productdetail/${Encryption(item?.Id)}`
                            //             );

                            //             handleGetProduct();
                            //             window.scrollTo(0, 0);
                            //           }}
                            //         />
                            //       </div>
                            //     </div>
                            //     <div className="pro_desc_spacing-new">
                            //       <div className="pro_detail_modal_pointer">
                            //         <h2>{item?.ProductName} </h2>
                            //         <p>{item?.ProductDescription}</p>
                            //         {item?.IsProductInOffer == false ? (
                            //           <h3>
                            //             Deal Price<span>₹ {item?.DealPrice}</span>
                            //           </h3>
                            //         ) : null}
                            //         <h3>
                            //           MRP<span>₹ {item?.Mrp}</span>
                            //         </h3>
                            //         {timeDifferenceInHours > 24 ? (
                            //           <h3>
                            //             <strong>
                            //               Till:{" "}
                            //               {moment(item?.ToPushlishDate).format(
                            //                 "LL"
                            //               )}
                            //             </strong>
                            //           </h3>
                            //         ) : (
                            //           <ProductCountdown
                            //             item={item}
                            //             val="tillTime"
                            //           />
                            //         )}
                            //       </div>
                            //       <div className="mb-0">
                            //         {item?.IsProductOutOfStock === true ? (
                            //           <input
                            //             type="button"
                            //             value="Out of Stock"
                            //             className="common_btn_new out_stock_btn_01"
                            //           />
                            //         ) : (
                            //           <input
                            //             onClick={() => {
                            //               router(
                            //                 `/productdetail/${Encryption(item?.Id)}`
                            //               );

                            //               handleGetProduct();
                            //               window.scrollTo(0, 0);
                            //             }}
                            //             type="button"
                            //             value={
                            //               item?.IsProductInOffer == true
                            //                 ? "Bid Now"
                            //                 : item?.IsProductInOffer == false
                            //                 ? "Buy Now"
                            //                 : item?.IsProductInOffer === null
                            //                 ? "Contact Us"
                            //                 : null
                            //             }
                            //             className={
                            //               item?.IsProductInOffer == true
                            //                 ? "common_btn_new bid_now_btn_01"
                            //                 : item?.IsProductInOffer == false
                            //                 ? "common_btn_new"
                            //                 : item?.IsProductInOffer == null
                            //                 ? "common_btn_new"
                            //                 : null
                            //             }
                            //           />
                            //         )}
                            //       </div>
                            //     </div>
                            //   </div>
                            // </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showAddressModal}
        onHide={handleCloseAddress}
        backdrop="static"
      >
        <Modal.Header className="add-address-close-icon" closeButton>
          <Modal.Title className="shipping-address-heading">
            Shipping Address{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="add-Address-main-container">
            <Form.Group controlId="formMobile">
              <Form.Label>
                Mobile Number <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter 10-digit mobile number"
                name="mobile"
                value={Address.mobile}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    mobile: e?.target?.value,
                  })
                }
                maxLength={10}
              />
            </Form.Group>
            <Form.Group controlId="formPincode">
              <Form.Label>
                Pincode <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter pincode"
                name="pincode"
                value={Address.pincode}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    pincode: e?.target?.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group controlId="formAddress">
              <Form.Label>
                Address (Area and Street/House No.) <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your address"
                name="address"
                value={Address.address}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    address: e?.target?.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group controlId="formLocality">
              <Form.Label>
                Locality <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter locality"
                name="locality"
                value={Address.locality}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    locality: e?.target?.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group controlId="formCity">
              <Form.Label>
                City <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter city"
                name="city"
                value={Address.city}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    city: e?.target?.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group controlId="formState">
              <Form.Label>
                State <span>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter state"
                name="state"
                value={Address.state}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    state: e?.target?.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group controlId="formLandmark">
              <Form.Label>Landmark (Optional)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter landmark (optional)"
                name="landmark"
                value={Address.landmark}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    landmark: e?.target?.value,
                  })
                }
              />
            </Form.Group>
            <Form.Group controlId="formAltPhone">
              <Form.Label>Alternative Phone Number (Optional)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter alternative phone number (optional)"
                name="altPhone"
                value={Address.altPhone}
                onChange={(e) =>
                  setAddress({
                    ...Address,
                    altPhone: e?.target?.value,
                  })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="Add-address-modal-save-button"
            variant="primary"
            onClick={handleAddAddress}
          >
            Save Address
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProductDetailComponent;
